import PerformanceMetrics from "../../model/performance/PerformanceMetrics.js";
import Page from "../framework/Page.js";
import ParentView from "../framework/ParentView.js";
import { PageIds } from "../PageIds.js";
import PerformanceMetricsRow from "./PerformanceMetricsRow.js";

export default class PerformanceMetricsPopupView extends ParentView  {
    /**
     * @param {string} parentId 
     */
    constructor(parentId) {
        super(parentId, PageIds.PERFORMANCE_POPUP);


        /**
         * @type {HTMLElement}
         */
        this.container = null;

        /**
         * @type {HTMLElement}
         */
        this.contentElement = null;

        /**
         * @type {string}
         */
        this.displayedContent = null;

        /**
         * @constant
         * @type {number}
         */
        this.prevTimestamp = Date.now() - 1000;

        /**
         * @constant
         */
        this.currentKeys = {};
    }

    /**
     * Invoked at startup or after a save has been loaded.
     * @override
     */
    initializeView() {
        const parentElement = Page.getElement(this.parentId);
        const popupElement = Page.createElement('div', parentElement, this.getElementId(), 'popup-window-prestige');

        const container = Page.createElement('div', popupElement, null, null);

        ////////////////////////////////////////
        // Header
        ////////////////////////////////////////

        const header = Page.createElement('div', container, null, 'popup-window-header');
        header.innerHTML = 'Performance Info';

        const thisRef = this;

        header.onclick = function () {
            thisRef.setViewVisible(false);
            return false;
        };

        ////////////////////////////////////////
        // Content
        ////////////////////////////////////////

        const sectionBody = Page.createElement('div', container, null, 'menu-section-body');

        this.container = Page.createElement('div', sectionBody, null, null);
        
        //////////////////////////////////////////
        // Main Content
        //////////////////////////////////////////
                
        this.contentElement = Page.createElement('div', this.container, 'performanceContent', 'offline-info');

        //////////////////////////////////////////
        // Header Row
        //////////////////////////////////////////

        const headerRow = Page.createElement('div', this.contentElement, null, 'performance-row');

        const labelSpan = Page.createElement('span', headerRow, null, null);
        labelSpan.innerHTML = 'Activity';

        const countSpan = Page.createElement('span', headerRow, null, 'performance-value');
        countSpan.innerHTML = 'Count';

        const averageSpan = Page.createElement('span', headerRow, null, 'performance-value');
        averageSpan.innerHTML = 'Ave Millis';

        const totalSpan = Page.createElement('span', headerRow, null, 'performance-value');
        totalSpan.innerHTML = 'Tot Millis';


        //////////////////////////////////////////
        // Reset button
        //////////////////////////////////////////

        const buttonRow = Page.createElement('div', this.container, null, 'save-popup-button-row');

        const resetButton = Page.createElement('div', buttonRow, 'resetButton', 'game-button prestige-button');
        resetButton.style.marginTop = '10px';
        resetButton.innerHTML = 'Reset';

        resetButton.onclick = function () {
            PerformanceMetrics.reset();
            this.displayedContent = null; // force ui refresh.
            return false;
        };

        this.setInitialVisibility(false);

        super.initializeView();
    }

    /**
     * @override
     */
    updateViewContents() {
        const timestamp = Date.now();
        const elapsed = timestamp - this.prevTimestamp;
        
        if (elapsed > 1000) {
            this.prevTimestamp = timestamp;

            const keys = PerformanceMetrics.getKeys();
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];

                if (!this.currentKeys[key]) {
                    this.currentKeys[key] = true;

                    const performanceTrack = PerformanceMetrics.getPerformanceTrack(key);
                    if (performanceTrack) {
                        const metricsRowView = new PerformanceMetricsRow('performanceContent', 'performanceContent_' + i, performanceTrack);
                        this.addView(metricsRowView);

                        // We need to initialize the view here.
                        metricsRowView.initializeView();
                    }
                    else {
                        console.log('PerformanceMetricsPopupView.updateViewContents() failed to find: ' + key);
                    }
                }
            }
        }

        super.updateViewContents();
    }
}